import {observer} from "mobx-react";
import {growlStore, userListStore, userStore} from "../../../store";
import {ScrollTable} from "../../ui";
import {useNavigate} from "react-router-dom";

import "./UserTable.scss"
import {UserListItemDto} from "../../../api";

function getStandort(u: UserListItemDto): string {
    return u.organizations.map(o => {
        const costCenter = o.costCenter ? ` (${o.costCenter})` : ''
        return `${o.name}${costCenter}`
    }).join(', ')
}

const UserTable = observer(function UserTable() {
    const navigate = useNavigate()
    return <ScrollTable>
        <thead>
        <tr>
            <th>Kennung</th>
            <th>Vorname</th>
            <th>Nachname</th>
            <th>Standort</th>
            <th>E-Mail</th>
            <th></th>
        </tr>
        </thead>
        <tbody className={"user-table"}>
        {!userListStore.users.length &&
            <tr>
                <td className="empty-colum" colSpan={5}>
                    Es konnten leider keine Einträge angezeigt werden. Bitte passen Sie Ihre Suche an.
                </td>
            </tr>
        }
        {userListStore.users.map(u => {
            const iconClass = u.active ? "active" : "inactive"
            const toggleActive = async () => {
                const oldActiveState = u.active
                await userStore.toggleActive(u)
                growlStore.addMessage({
                    message: oldActiveState ? 'Benutzer wurde deaktiviert': 'Benutzer wurde aktiviert',
                    type: 'success',
                    autoHide: true
                })
            }
            const standort = getStandort(u)
            return <tr key={u.id} className={`user ${iconClass}`}>
                <td><a href={`${window.location.href}/${u.id}`} onClick={(e) => {
                    e.preventDefault()
                    navigate(u.id)
                }}>{u.username}</a></td>
                <td>{u.firstName}</td>
                <td>{u.lastName}</td>
                <td title={standort}>{standort}</td>
                <td>{u.email}</td>
                <td style={{ display: 'flex', justifyContent: 'end' }}>
                    <span onClick={toggleActive} className={`material-symbols-outlined ${iconClass}`} style={{cursor: "pointer"}}>{u.active?'toggle_on':'toggle_off'}</span>
                </td>
            </tr>
        })}
        </tbody>
    </ScrollTable>
})

export {
    UserTable
}
